import {Component, OnInit, Output, EventEmitter, AfterViewChecked, ChangeDetectorRef} from '@angular/core';
import * as L from 'leaflet';
import 'bingmaps';
import 'leaflet-bing-layer';
import 'leaflet/dist/leaflet.js';
import 'leaflet-spin/leaflet.spin';
import {RoutingDemoPageService} from '../services/routing-demo-page-service';

@Component({
  selector: 'app-view-map',
  templateUrl: './view-map.component.html',
  styleUrls: ['./view-map.component.css']
})

export class ViewMapComponent implements OnInit, AfterViewChecked {
  @Output() finishedLoading: EventEmitter <boolean> = new EventEmitter<boolean>();
  map: any;
  layerGroup: any;
  constructor(private routingDemoPageService: RoutingDemoPageService) {
    this.routingDemoPageService.init();
    /*this.tb.ngOnInit();*/
  }

  ngOnInit() {
    const BING_KEY = 'AmNbl1XqrIQVy1RWC2v4ownaDYnyt6n5lEsmTDCQLXWSTaX74eQ7652WWC6XmLL3';
    const IMAGERY_TYPE = 'RoadOnDemand';
    this.map = L.map('map').setView([43, -74], 10);
    L.tileLayer.bing({bingMapsKey: BING_KEY, imagerySet: IMAGERY_TYPE, }).addTo(this.map);
    this.layerGroup = new L.LayerGroup().addTo(this.map);
    this.routingDemoPageService.map = this.map;
    this.routingDemoPageService.layerGroup = this.layerGroup;
  }
  ngAfterViewChecked() {
    this.finishedLoading.emit(true);
  }

}
